export const ImageSize = {
  Small: 400,
  Large: 750,
};

export const ActionType = {
  Link: 'Link',
  Button: 'Button',
};

export default {
  ImageSize,
  ActionType,
};
